import React from 'react'
import './GameCardEffect.css'
function GameCardEffect() {
  return (
    <div
      className="col-12 col-sm-6 col-lg-4"
    >
      {/* {console.log(props.element.stores[Math.floor(Math.random()*props.element.stores.length)].store.slug)} */}
      {/* ==== Game ==== */}
      <div className=" Skelton__container  ">
        {/* ==== Game Img ==== */}




      </div>
    </div>
  )
}

export default GameCardEffect